module.exports = __webpack_public_path__ + "static/media/SH.7f802bfc.svg";